import axios from '@dap/shared-utils/http.js';
import { postJson, putJson } from '@dap/shared-utils/http';

export default {
    getTableList (type, params = {}) {
        const typeMap = new Map();
        typeMap.set('account', 'accounts');
        typeMap.set('project', 'campaigns');
        typeMap.set('ad', 'ads');
        return axios.get(`/dapper/api/toutiao_ad3/${typeMap.get(type)}`, {
            params,
        });
    },

    // 更新项目/广告状态 type: project/promotion
    updateProjectStatus (type, params) {
        return axios.put(`/dapper/api/toutiao_ad3/${type}/update_status`, params);
    },

    // 删除项目/广告 type: project/promotion
    deleteProject (type, params) {
        return axios.delete(`/dapper/api/toutiao_ad3/${type}`, {
            data: params,
        });
    },

    // 修改项目预算 type: project/promotion
    updateBudget (type, params) {
        return axios.put(`/dapper/api/toutiao_ad3/${type}/update_budget`, params);
    },

    // 推送进度
    getPushProcess (params = {}) {
        return axios.get('/dapper/api/toutiao_ad3/sync/process', { params });
    },

    // 更新广告出价
    updateBidding (params) {
        return axios.put('/dapper/api/toutiao_ad3/promotion/update_bidding', params);
    },

    // 获取头条字典
    getToutiaoDict () {
        return axios.get('/dapper/api/toutiao_ad3/dict');
    },
    getToutiao2Dict (params = {}) {
        return axios.get('/dapper/api/toutiao_ad/dict', { params });
    },
    // 获取事件列表
    getEventList (params = {}) {
        return axios.get('/dapper/api/toutiao_ad/events', { params });
    },
    // 新建事件
    addEvent (params = {}) {
        return axios.post('/dapper/api/toutiao_ad/events', params);
    },
    getCommon (params = {}) {
        return axios.get('/dapper/api/ad/common', { params });
    },
    // 获取上次创建内容， (草稿接口，返回自定义字段)
    getLastData (params = {}) {
        return axios.get('/dapper/api/toutiao_ad3/batch/get_last_batch_detail', { params });
    },
    // 23. 创建草稿
    createLastBatch (params = {}) {
        return postJson('/dapper/api/toutiao_ad3/batch/create_last_batch', params);
    },
    // 25. 批量预提交
    createBatch (params = {}) {
        return postJson('/dapper/api/toutiao_ad3/batch/create_batch', params);
    },
    // 26. 批量预览
    getBatchList (params = {}) {
        return axios.get('/dapper/api/toutiao_ad3/batch/batch_list', {
            params,
        });
    },
    // 27. 批量提交
    commitBatch (params = {}) {
        return postJson('/dapper/api/toutiao_ad3/batch/commit_batch', params);
    },
    // 24. 选择已有项目
    searchCampaignGroup (params = {}) {
        return axios.get('/dapper/api/toutiao_ad2/search', { params });
    },
    // 2. 项目名称自动命名
    projectAutoName (params = {}) {
        return axios.get('/dapper/api/toutiao_ad3/project/auto_name', {
            params,
        });
    },
    // 2. 广告名称自动命名
    adAutoName (params = {}) {
        return axios.get('/dapper/api/toutiao_ad3/promotion/auto_name', {
            params,
        });
    },
    // 6. 创建项目
    projectCreate (params = {}) {
        return axios.post('/dapper/api/toutiao_ad3/project', params, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    },

    updateCreate (params = {}) {
        return axios.put('/dapper/api/toutiao_ad3/project', params, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    },

    // 查看项目
    projectQuery (params = {}) {
        return axios.get('/dapper/api/toutiao_ad3/project', { params });
    },

    // 14. 创建广告
    adCreate (params = {}) {
        return axios.post('/dapper/api/toutiao_ad3/promotion', params, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    },

    updateAd (params = {}) {
        return axios.put('/dapper/api/toutiao_ad3/promotion', params, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    },

    // 查看项目
    adQuery (params = {}) {
        return axios.get('/dapper/api/toutiao_ad3/promotion', { params });
    },

    updateAccountBudget (params = {}) {
        return axios.put('/dapper/api/toutiao_ad3/account/update_budget', params, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    },

    // 更新项目名称
    updateProjectName (params = {}) {
        return axios.put('/dapper/api/toutiao_ad3/project/update_name', params, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    },

    updateProjectDelivery (params = {}) {
        return axios.put('/dapper/api/toutiao_ad3/project/update_delivery_type', params, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    },

    updateAdBudget (params = {}) {
        return axios.post('/dapper/api/toutiao_ad3/promotion/update_budget', params, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    },
    // 30. 项目操作日志
    getProjectLogOpeData (params = {}) {
        return axios.get('/dapper/api/toutiao_ad3/project/opt_log', { params });
    },
    // 30. 项目日志
    getProjectLogData (params = {}) {
        return axios.get('/dapper/api/toutiao_ad3/project/log', { params });
    },

    // 30. 项目操作日志
    getAdLogOpeData (params = {}) {
        return axios.get('/dapper/api/toutiao_ad3/promotion/opt_log', {
            params,
        });
    },
    // 30. 项目日志
    getAdLogData (params = {}) {
        return axios.get('/dapper/api/toutiao_ad3/promotion/log', { params });
    },

    // 更新项目名称
    updateAdName (params = {}) {
        return axios.put('/dapper/api/toutiao_ad3/promotion/update_name', params, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    },

    updateDeepBidding (params) {
        return axios.put('/dapper/api/toutiao_ad3/promotion/update_deep_cpabid', params);
    },
    updateRoi (params) {
        return axios.put('/dapper/api/toutiao_ad3/promotion/update_roi_goal', params);
    },
    setAdgroupLabelRelation (params = {}) {
        return axios.post('/dapper/api/adgroup_label_relation', params, {
            headers: { 'Content-Type': 'application/json' },
        });
    },

    // 获取投放账户
    getAccountList (params = {}) {
        return axios.get('/dapper/api/acc/accounts', { params });
    },
    // 获取抖音账号
    getTiktokList (params = {}) {
        return axios.get('/dapper/api/toutiao_ad/aweme', { params });
    },
    // 锚点列表
    getToutiaoAnchor (params = {}) {
        return axios.get('/dapper/api/toutiao_ad/anchor', { params });
    },
    // 获取广告组关键词列表
    getkeywordPreview (params = {}) {
        return axios.get('/dapper/api/keyword/preview', { params });
    },
    /**
     * 预览页修改项目名称
     * @param {*} params 
     */
    updateBatchAdCampaignsName (params = {}) {
        return putJson('/dapper/api/toutiao_ad3/batch/batch_ad_campaigns', params);
    },
    /**
     * 预览页修改广告名称
     * @param {*} params 
     */
    updateBatchAdsName (params = {}) {
        return putJson('/dapper/api/toutiao_ad3/batch/batch_ad_ads', params);
    },
    /**
     * 预览页获取广告统计信息
     * 项目数量那种
     * @param {*} params 
     * @returns 
     */
    getAdsStatistics (params = {}) {
        return postJson('/dapper/api/toutiao_ad3/statistics', params);
    },
    /**
     * 新增的接口
     * 校验批量创建入参合法性
     * 预提交之前的预校验，即预预提交
     * @param {*} params 
     * @returns 
     */
    createBatchCheck (params = {}) {
        return postJson('/dapper/api/toutiao_ad3/batch/create_batch/check', params);
    }


};
